
import axios from 'axios'
const API_URL = 'https://swe-meeting-backend.onrender.com';

export const createAdmin = async (user)=> {
    const response = await axios.post(`${API_URL}/admin/createAdmin`, user);
    return response;
}

export const getAdmin = async (id, password)=> {
    const response = await axios.get(`${API_URL}/admin/getAdmin/${id}/${password}`);
    return response;
}

export const createUser = async(user)=>{
    const response = await axios.post (`${API_URL}/users/createUser`, user);
    return response;
}
export const getUser = async(netID)=>{
    const response = await axios.get(`${API_URL}/users/getUser/${netID}`);
    return response;
}

export const getUsers = async()=>{
    const response = await axios.get(`${API_URL}/users/getUsers`);
    return response;
}

export const getUsersMeetingReset = async(meetingReset)=>{
    const response = await axios.get(`${API_URL}/users/getUsersMeetingReset/${meetingReset}`);
    return response;
}

export const secretCode = async(id)=>{
    const response = await axios.get(`${API_URL}/admin/secretCode/${id}`);
    return response;
}

export const changeSecretCode = async(id, newSecret)=>{
    const response = await axios.put(`${API_URL}/admin/changeSecretCode/${id}/${newSecret}`);
    return response;
}

export const meetingResetGet = async(netID)=>{
    const response = await axios.get(`${API_URL}/users/meetingResetGet/${netID}`);
    return response;
}

export const meetingReset = async(netID, meetingReset)=>{
    const response = await axios.put(`${API_URL}/users/meetingReset/${netID}/${meetingReset}`);
    return response;
}

export const meetingsGet = async(netID)=>{
    const response = await axios.get(`${API_URL}/users/meetingsGet/${netID}`);
    return response;
}

export const meetingsOther = async(netID, meetings)=>{
    const response = await axios.put(`${API_URL}/users/meetingsOther/${netID}/${meetings}`);
    return response;
}
export const meetingsOtherGet = async(netID)=>{
    const response = await axios.get(`${API_URL}/users/meetingsOtherGet/${netID}`);
    return response;
}

export const meetings = async(netID, meetings)=>{
    const response = await axios.put(`${API_URL}/users/meetings/${netID}/${meetings}`);
    return response;
}

export const getMeetingOpening = async(id)=>{
    const response = await axios.get(`${API_URL}/admin/getMeetingOpening/${id}`);
    return response;
}

export const setMeetingOpening = async(id, meetingOpening)=>{
    const response = await axios.put(`${API_URL}/admin/meetingOpening/${id}/${meetingOpening}`);
    return response;
}

export const allMeetingReset = async (meetingReset) => {
    const response = await axios.put(`${API_URL}/users/allMeetingReset/${meetingReset}`);
    return response;
};

export const deleteUser = async(netID)=>{
    const response = await axios.delete(`${API_URL}/users/deleteUser/${netID}`);
    return response;
}